export default __webpack_public_path__ + "static/media/sukron-ya-rabb.042241ef.mp3";